import React from 'react';
import { useSiteContent } from '../context/SiteContentContext';
import { resolveImageUrl } from '../utils/urls';

const PartnersStrip = () => {
  const { partners } = useSiteContent();
  if (!partners || partners.length === 0) return null;
  const strip = [...partners, ...partners];

  return (
    <section className="py-12 bg-white border-t border-gray-100" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <p className="text-sm font-semibold text-[#0a3d8f] uppercase tracking-widest mb-2">Dipercaya Oleh</p>
          <h3 className="text-2xl lg:text-3xl font-extrabold text-gray-900">Mitra Telekomunikasi Terkemuka</h3>
        </div>
        <div className="relative overflow-hidden w-full">
          <div className="flex gap-8 marquee w-max">
            {strip.map((p, i) => {
              const logo = resolveImageUrl(p.logo);
              return (
                <a
                  key={`${p.id}-${i}`}
                  href={p.website || '#'}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`partner-${p.id}`}
                  title={`Buka website ${p.name}`}
                  className="shrink-0 min-w-[160px] h-16 px-6 flex items-center justify-center bg-gray-50 rounded-md border border-gray-100 text-gray-600 font-semibold text-sm tracking-wide hover:bg-blue-50 hover:text-[#0a3d8f] hover:border-[#0a3d8f]/30 transition-colors"
                >
                  {logo ? (
                    <img src={logo} alt={p.name} className="max-h-10 w-auto object-contain" />
                  ) : (
                    <span>{p.name}</span>
                  )}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersStrip;
